export default "__VITE_ASSET__CMco9yOb__"